import { button } from '../../../../../component/component'

export default function(o,p){

  var save = function(){

    if(div.getDisabled()){
      return
    }

    if(p.item){
      update()
    } else {
      insert()
    }

  }

  var insert = function(){

    var item = {}
    _.each(
      p.changes,
      function(change){
        item[change.id] = change.value
      }
    )

    p.model.insert(o,item,function(error,i){

      if(error){
        throw error

      } else {
        if(p.done){
          p.done(i)

        }
      }
    })

  }

  var update = function(){

    var item = p.item

    var id = item._id
    var changes = p.changes

    p.model.update(o,id,changes,function(error){

      if(error){
        throw error

      } else {
        if(p.done){
          p.done()

        }
      }
    })

  }

  var div =
    button(null,'fi-check',true)
    .addClass('mousetrapShiftEnter')
    .css({
      position: 'absolute',
      right: '68px',
    })
    .click(save)

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/edit/form/save/save.js